import cn from 'classnames';

import Image from 'components/image/Image';
import { imageSizes } from 'components/image/image-sizes';
import Heading from 'components/heading/Heading';
import LinkWrapper from 'components/link-wrapper/LinkWrapper';

import { IProcessItem } from 'source/NFR.types';

interface ProcessItemProps extends IProcessItem {
  index: number;
}

const ProcessItem: React.FC<ProcessItemProps> = ({ icon, text, index, url, title }) => {
  const { OuterLink } = LinkWrapper(!!url, url);

  return (
    <div className={cn('process-item')}>
      <OuterLink
        className={cn('process-item--link', {
          'process-item--link--has-link': url
        })}
        noHoverEffect={true}
      >
        <div className="process-item--wrapper">
          <div className="process-item--header">
            {icon ? (
              <div className="process-item--icon-container">
                <Image className="process-item--icon" {...icon} {...imageSizes.icon.large} />
              </div>
            ) : (
              <Heading className="process-item--number" level={2}>
                {index + 1}
              </Heading>
            )}
          </div>

          {title && (
            <p className="process-item--title">
              <span>{title}</span>
            </p>
          )}
          {text && (
            <p
              className={cn('process-item--text', {
                'process-item--text-hover': !title
              })}
            >
              <span>{text}</span>
            </p>
          )}
        </div>
      </OuterLink>
    </div>
  );
};

ProcessItem.displayName = 'ProcessItem';

export default ProcessItem;
